export function toast(message, url, type = "primary") {
  // Make sure Bootstrap is loaded
  if (!window.bootstrap) {
    console.error("Bootstrap JS not loaded!");
    return;
  }

  // Create toast container if it doesn’t exist
  let container = document.querySelector(".toast-container");
  if (!container) {
    container = document.createElement("div");
    container.className = "toast-container position-fixed bottom-0 start-0 p-3 rounded-md";
    document.body.appendChild(container);
  }

  // Create a new toast element
  const toastEl = document.createElement("div");
  toastEl.className = `toast-${type} toast align-items-center text-bg-${type} border-0`;
  toastEl.role = "alert";
  toastEl.ariaLive = "assertive";
  toastEl.ariaAtomic = "true";

  if (type === "created") {
      toastEl.innerHTML = `
        <div class="">
          <div class="toast-body">

          <div class="d-flex justify-content-between align-items-center">
            <h5 class="toast-text-header toast-text-header-${type}"> ${type}</h5>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"> <i class="bi bi-x"></i> </button>
          </div>

            <p class="toast-text-body toast-text-body-${type} mb-0"> ${message} </p>
            <a href="${url}" class="btn toast-button-${type}"> go to event </a>
       
          <p class="toast-text-body toast-text-body-${type} mb-0">    </p>
          </div>
        
        </div>
        `;

  } else {
          toastEl.innerHTML = `
        <div class="">
          <div class="toast-body">

          <div class="d-flex justify-content-between align-items-center">
            <h5 class="toast-text-header toast-text-header-${type}"> ${type}</h5>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"> <i class="bi bi-x"></i> </button>
          </div>

          <p class="toast-text-body toast-text-body-${type} mb-0"> ${message} </p>
          </div>
        
        </div>
        `;
    }
      
    


  // Append to container
  container.appendChild(toastEl);

  // Initialize and show toast
  const toast = new window.bootstrap.Toast(toastEl, {
    delay: 3000,
    autohide: true,
  });
  toast.show();

  // Remove toast element after it hides
  toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove());
}
